module.exports = __webpack_public_path__ + "static/media/galleryImg26.33484f3c.jpg";